import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {RouterModule} from "@angular/router";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { OcorrenciaComponent } from "./ocorrencia.component";
import { CadastroOcorrenciaComponent } from "./cadastro.component";

import { NgxSummernoteModule } from 'ngx-summernote';
import { NgxMaskModule } from 'ngx-mask'

@NgModule({
  declarations: [
    OcorrenciaComponent,
    CadastroOcorrenciaComponent
  ],
  imports: [
    BrowserModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSummernoteModule,
    NgxMaskModule.forRoot(),
  ],
  exports: [
    OcorrenciaComponent,
    CadastroOcorrenciaComponent
  ]
})

export class OcorrenciaModule {}
